import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-date-picker';

import { decodeFormValue } from 'utils/forms';
import moment from 'moment';

class DatePicker extends React.Component {
    static propTypes = {
        fieldValue: PropTypes.string,
        fieldName: PropTypes.string.isRequired,
        provideDefaultDate: PropTypes.bool,
    };
    static defaultProps = {
        fieldValue: undefined,
        provideDefaultDate: true,
    };

    constructor(props) {
        super(props);
        const { initialDate, provideDefaultDate, fieldValue, fieldName, fieldError, ...datePickerProps } = props;

        const initialState = {
            datePickerProps,
        };

        if (fieldValue) {
            initialState.date = new Date(decodeFormValue(fieldValue));
        } else {
            if (provideDefaultDate) {
                if (moment.isDate(initialDate)) {
                    initialState.date = initialDate;
                } else {
                    initialState.date = new Date();
                }
            }
        }
        this.state = initialState;
    }

    onChange = (date) => this.setState({ date });

    render() {
        const { date, datePickerProps } = this.state;
        const inputProps = { name: this.props.fieldName };

        if (!date) {
            inputProps.clearIcon = null;
        }

        return (
            <div>
                <ReactDatePicker
                    onChange={this.onChange}
                    value={date}
                    locale={DJ_CONST.LANGUAGE_CODE}
                    {...datePickerProps}
                    {...inputProps}
                />
            </div>
        );
    }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker.js